import React, {useContext} from 'react';
import LogosContext from "app/react/components/logos/LogosContext";
import File from 'app/react/components/File'

export default function Files () {

  const { files } = useContext(LogosContext)

  return (
    <>
      {files.length > 0 && (
        <div className="dm-image-text__files">
          {files.map((file, i) => <File key={i} {...file} />)}
        </div>
      )}
    </>
  )
}